import { jsx as n } from "react/jsx-runtime";
import { Layers as N, Router as P, SignalCellularAlt as l, Satellite as r } from "@mui/icons-material";
const _ = (t, a) => ({
  FLOOR_PLAN: {
    icon: (o) => o || /* @__PURE__ */ n(N, { sx: t, ...a }),
    tooltip: "Floor Plan"
  },
  RF_PLAN: {
    icon: (o) => o || /* @__PURE__ */ n(r, { sx: t, ...a }),
    tooltip: "RF Plan"
  },
  SINR_PLAN: {
    icon: (o) => o || /* @__PURE__ */ n(l, { sx: t, ...a }),
    tooltip: "SINR Plan"
  },
  DOMINANT_CELL_PLAN: {
    icon: (o) => o || /* @__PURE__ */ n(P, { sx: t, ...a }),
    tooltip: "Dominant Cell Plan"
  },
  CUSTOM_PLAN: {
    icon: (o) => o || /* @__PURE__ */ n(N, { sx: {
      ...t,
      transform: "rotate(90deg)"
    }, ...a }),
    tooltip: "Custom Plan"
  }
}), e = (t, a, o) => {
  let L;
  switch (t) {
    case "FLOOR_PLAN":
      L = /* @__PURE__ */ n(N, { sx: a, ...o });
      break;
    case "RF_PLAN":
      L = /* @__PURE__ */ n(r, { sx: a, ...o });
      break;
    case "SINR_PLAN":
      L = /* @__PURE__ */ n(l, { sx: a, ...o });
      break;
    case "DOMINANT_CELL_PLAN":
      L = /* @__PURE__ */ n(P, { sx: a, ...o });
      break;
    case "CUSTOM_PLAN":
      L = /* @__PURE__ */ n(N, { sx: {
        ...a,
        transform: "rotate(90deg)"
      }, ...o });
      break;
    default:
      L = /* @__PURE__ */ n(N, { sx: a, ...o });
      break;
  }
  return L;
};
export {
  e as getPlanIconComponent,
  _ as getPlanIconsAndTooltips
};
